// src/components/Cards/AdminStatsCard.tsx
import { FC } from "react";
import { ReactComponent as StatsBoardDesign } from "../../assets/img/statBoardDesign.svg";
import { DashboardCard } from "./DashboardCard";
import { Body } from "../UIKits/Typography/Typography";

interface StatItem {
  label: string;
  value: string;
}

interface AdminStatsCardProps {
  stats: StatItem[];
  loading?: boolean;
}
interface InfoItemProps {
  label: string;
  value: string;
}

export const AdminStatsCard: FC<AdminStatsCardProps> = ({ stats, loading }) => {
  return (
    <DashboardCard gradient="white" className="w-full border border-ash  min-h-[200px]   flex-col">
      <div className="w-11/12 mx-auto  mt-10 mb-5  flex justify-between">
        {loading ? "Loading..." : stats.map((stat, index) => (
          <div key={index}>
            <div className={`space-y-1 px-2  ${index < stats.length - 1 && 'border-r '}`}>
              {/* <p className="text-lightBlack text-xs">{stat.label}</p> */}
              <Body color="secondary" className="text-[10px] md:text-sm"> {stat.label}</Body>
              <Body variant="body" className="font-semibold text-lg">{stat.value}</Body>
            </div>
             
          </div>
        ))}
      </div>
      <span className="w-10/12">
        <StatsBoardDesign />
      </span>
    </DashboardCard>
  );
};

//InfoItem.tsx


const InfoItem: FC<InfoItemProps> = ({ label, value }) => {
  return (
    <div>
      <Body className="text-lightBlack text-xs">{label}</Body>
      <Body className="m-0 font-medium">{value}</Body>
    </div>
  );
};

export { InfoItem };